<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <loading-spinner v-if="isLoading"></loading-spinner>

        <paginated-table
          v-else
          :title="$t('title.all_submission_status')"
          icon="manage_search"
          :columns="columns"
          :data="papers"
          @updatePagination="updatePagination"
        >
          <template v-slot:top-buttons>
            <v-select
              v-model="selectedCategory"
              :items="categoryOptions"
              item-text="label"
              item-value="value"
              :label="$t('label.paper_category')"
              outlined
              dense
              hide-details
              class="mr-3"
              style="max-width: 160px"
              @change="onFilterChange"
            ></v-select>
            <v-select
              v-model="selectedStatus"
              :items="statusOptions"
              item-text="label"
              item-value="value"
              :label="$t('label.status')"
              outlined
              dense
              hide-details
              style="max-width: 140px"
              @change="onFilterChange"
            ></v-select>
          </template>
        </paginated-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import PaginatedTable from "@/components/Tables/PaginatedTable.vue";
import LoadingSpinner from "@/components/common/Spinners/LoadingSpinner.vue";

import { getAdminPaperStatusColumns } from "@/fields/paper/columns";

import { paperApi } from "@/api/api";

const CATEGORY_OPTIONS = [
  { value: "SUBMISSION",    label: "투고" },
  { value: "REVIEW",        label: "심사" },
  { value: "FINAL_REVIEW",  label: "총평" },
  { value: "REVISION",      label: "수정" },
  { value: "FINAL_REVISION",label: "수정 후 게재" },
  { value: "PUBLICATION",   label: "게재" },
  { value: "REJECTED",      label: "게재 불가" },
  { value: "RESUBMISSION",  label: "재투고" },
];

const STATUS_OPTIONS = [
  { value: "WAITING",     label: "작업 대기" },
  { value: "IN_PROGRESS", label: "작업중" },
  { value: "COMPLETED",   label: "작업완료" },
];

export default {
  components: {
    PaginatedTable,
    LoadingSpinner,
  },
  data() {
    return {
      papers: {
        page_info: {
          page: 0,
          size: 0,
          total_elements: 0,
          total_pages: 0,
        },
        elements: [],
      },
      isLoading: false,
      selectedCategory: "SUBMISSION",
      selectedStatus: "WAITING",
      categoryOptions: CATEGORY_OPTIONS,
      statusOptions: STATUS_OPTIONS,
      columns: getAdminPaperStatusColumns({
        edit: this.handleEdit,
        showDetail: this.handleShowPaperDetail,
      }),
    };
  },
  methods: {
    toEditPaper(paper) {
      this.$router.push({
        name: "submission-edit",
        params: { idx: paper.idx },
      });
    },
    toPaperDetail(paper) {
      this.$router.push({
        name: "submission-detail",
        params: { idx: paper.idx },
      });
    },
    onFilterChange() {
      this.papers.page_info.page = 1;
      this.fetchPapers(this.papers.page_info.size, 1);
    },
    updatePagination(pagination) {
      this.papers.page_info.size = pagination.size;
      this.papers.page_info.page = pagination.page;
      this.fetchPapers(this.papers.page_info.size, this.papers.page_info.page);
    },
    async fetchPapers(size, page) {
      const params = {
        category: this.selectedCategory,
        status: this.selectedStatus,
        page: page ? page : 1,
        size: size ? size : 5,
        sort_by: "idx",
        direction: "desc",
      };

      try {
        this.isLoading = true;
        const response = await paperApi.getPapers(params);
        this.papers = response?.data?.response;
      } catch (error) {
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
      } finally {
        this.isLoading = false;
      }
    },
    async handleEdit(paper) {
      if (
        !["SUBMISSION", "REVISION", "FINAL_REVISION"].includes(paper.category) ||
        paper.status === "COMPLETED"
      ) {
        this.notifyVue({
          message: this.$t("alert.can_not_edit_paper"),
          horizontal: "center",
          style: "danger",
        });
        return;
      }
      await this.toEditPaper(paper);
    },
    async handleShowPaperDetail(paper) {
      await this.toPaperDetail(paper);
    },
    notifyVue({
      vertical = "top",
      horizontal = "right",
      message = "",
      style = "primary",
      icon = "priority_high",
    } = {}) {
      this.$notify({
        timeout: 8000,
        message,
        icon,
        type: style,
        horizontalAlign: horizontal,
        verticalAlign: vertical,
      });
    },
  },
  mounted() {
    this.fetchPapers(this.papers.page_info.size, this.papers.page_info.page);
  },
};
</script>
<style scoped>
.v-select {
  background-color: white;
}
</style>
